module.exports = "<div class=\"docs-component-viewer\">\n  <div class=\"docs-component-viewer-content\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/content-viewer/content-viewer.component.html
// module id = ../../../../../src/app/layout/content-viewer/content-viewer.component.html
// module chunks = main